var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3438 21.1562H1.65625C1.20684 21.1562 0.84375 20.7932 0.84375 20.3438V1.65625C0.84375 1.20684 1.20684 0.84375 1.65625 0.84375H20.3438C20.7932 0.84375 21.1562 1.20684 21.1562 1.65625V20.3438C21.1562 20.7932 20.7932 21.1562 20.3438 21.1562ZM7.34375 5.10938C7.34375 4.99766 7.25234 4.90625 7.14062 4.90625H5.10938C4.99766 4.90625 4.90625 4.99766 4.90625 5.10938V16.8906C4.90625 17.0023 4.99766 17.0938 5.10938 17.0938H7.14062C7.25234 17.0938 7.34375 17.0023 7.34375 16.8906V5.10938ZM12.2188 12.2188C12.2188 12.107 12.1273 12.0156 12.0156 12.0156H9.98438C9.87266 12.0156 9.78125 12.107 9.78125 12.2188V16.8906C9.78125 17.0023 9.87266 17.0938 9.98438 17.0938H12.0156C12.1273 17.0938 12.2188 17.0023 12.2188 16.8906V12.2188ZM17.0938 10.3906C17.0938 10.2789 17.0023 10.1875 16.8906 10.1875H14.8594C14.7477 10.1875 14.6562 10.2789 14.6562 10.3906V16.8906C14.6562 17.0023 14.7477 17.0938 14.8594 17.0938H16.8906C17.0023 17.0938 17.0938 17.0023 17.0938 16.8906V10.3906Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.44660fae41b13a2c99dd70f7ce7e496e.svg";
export { ForwardRef as ReactComponent };